import { ContractPageBase } from "../ContractPage/contract-page";

export abstract class OfferRequestPageBase extends ContractPageBase {

}
